import { render, staticRenderFns } from "./globalNotifications.vue?vue&type=template&id=bf2a8082"
import script from "./globalNotifications.vue?vue&type=script&lang=js"
export * from "./globalNotifications.vue?vue&type=script&lang=js"
import style0 from "./globalNotifications.vue?vue&type=style&index=0&id=bf2a8082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports